import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import PageWrapper from "../components/PageWrapper";
import "./Accessibility.css";

const contactEmail = "hello@mindblows.com";

export default function Accessibility() {
  const { t } = useTranslation();

  return (
    <PageWrapper>
      <div className="accessibility-page">
        <h1>{t("accessibility_title")}</h1>
        <p>{t("accessibility_intro")}</p>

        <section>
          <h2>{t("accessibility_standard_title")}</h2>
          <p>{t("accessibility_standard_body")}</p>
        </section>

        <section>
          <h2>{t("accessibility_measures_title")}</h2>
          <ul>
            <li>{t("accessibility_measure_1")}</li>
            <li>{t("accessibility_measure_2")}</li>
            <li>{t("accessibility_measure_3")}</li>
            <li>{t("accessibility_measure_4")}</li>
          </ul>
        </section>

        <section>
          <h2>{t("accessibility_limitations_title")}</h2>
          <p>{t("accessibility_limitations_body")}</p>
        </section>

        <section>
          <h2>{t("accessibility_feedback_title")}</h2>
          <p>{t("accessibility_feedback_body")}</p>
          <p>
            <a
              href={`mailto:${contactEmail}?subject=${encodeURIComponent(
                t("accessibility_email_subject")
              )}`}
            >
              {contactEmail}
            </a>
          </p>
          <p>{t("accessibility_response_time")}</p>
        </section>

        <section>
          <h2>{t("accessibility_related_title")}</h2>
          <p>
            <Link to="/support">{t("support")}</Link>
            {" · "}
            <Link to="/privacy-policy">{t("privacy_policy")}</Link>
            {" · "}
            <Link to="/terms">{t("terms")}</Link>
          </p>
        </section>
      </div>
      <Footer />
    </PageWrapper>
  );
}
